import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FaChevronDown } from 'react-icons/fa';
import { BsChat } from 'react-icons/bs';
import { getOpenWidgetBtnPosition, isValidPrice } from '../../../lib';
import * as constants from './../../../constants';

import './ToggleWidgetRoundBtn.css';

const ToggleWidgetRoundBtn = ({
    chatBtnOnClick,
    toggleWidgetRoundBtn,
    toggleWidget,
    widgetPosition,
    showWidget,
    enableXBtn,
    ourPrice,
    showOnlyWhenClosed = false,
    showCta = true,
}) => {
    // TODO: NEED TO REFACTOR THIS ONLY PASS THE PRICE THAT WE WANT TO DISPLAY??
    const isOpen = useSelector((state) => state.miniBookingWidget.open);
    const price = useSelector((state) => state.miniBookingWidget.price);
    const widgetVariant =
        useSelector((state) => state.miniBookingWidget?.data?.smallWidget) ||
        constants.SMALL;

    // TODO: REFACTOR THIS
    const [displayCta, setDisplayCta] = useState(
        (widgetVariant === constants.REGULAR ||
            widgetVariant === constants.HORIZONTAL) &&
            showCta
    );

    let openWidgetButtonStyles = getOpenWidgetBtnPosition(
        widgetPosition?.position
    );

    const btnContainerStyles = widgetPosition?.position?.includes('left')
        ? { marginLeft: 0 }
        : { marginLeft: 'auto' };

    if (toggleWidgetRoundBtn) {
        openWidgetButtonStyles = {
            ...openWidgetButtonStyles,
            backgroundColor: toggleWidgetRoundBtn.backgroundColor,
            color: toggleWidgetRoundBtn.color,
        };
    }

    const useLoyaltyPrice = isValidPrice(ourPrice?.loyaltyprice);

    if (!toggleWidgetRoundBtn) {
        return null;
    }

    const minPriceBtn = useRef(null);

    useEffect(() => {
        if (displayCta) {
            setTimeout(() => {
                if (minPriceBtn.current) {
                    minPriceBtn.current.classList.add('no-cta');
                    setTimeout(() => {
                        setDisplayCta(false);
                    }, 4500);
                }
            }, 2000);
        }
    }, [isOpen]);

    return (
        <>
            {showOnlyWhenClosed && isOpen ? null : (
                <div className="ab-button-container" style={btnContainerStyles}>
                    <div
                        className={`ab-min-price-btn ab-open-widget-btn ${
                            displayCta ? 'ab-min-price-btn-cta' : ''
                        }`}
                        onClick={toggleWidget}
                        style={openWidgetButtonStyles}
                        ref={minPriceBtn}
                    >
                        {isOpen && !displayCta ? (
                            <FaChevronDown size={28} />
                        ) : (
                            <>
                                {price || useLoyaltyPrice ? (
                                    <>
                                        {/* TODO: WHAT ABOUT 'rememberClose' */}
                                        {displayCta &&
                                            toggleWidgetRoundBtn?.btnText && (
                                                <div className="ab-cta">
                                                    {
                                                        toggleWidgetRoundBtn?.btnText
                                                    }
                                                </div>
                                            )}

                                        <div className="ab-min-price-btn-cnt">
                                            <span className="price">
                                                {useLoyaltyPrice
                                                    ? ourPrice?.loyaltyprice
                                                    : price}{' '}
                                                <sup className="currency-sign">
                                                    {ourPrice?.currencySymbol}
                                                </sup>
                                            </span>
                                            <span className="nights">
                                                {ourPrice?.nights}{' '}
                                                {ourPrice?.nightsText}
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                    <span className="price">
                                        {ourPrice?.text}
                                    </span>
                                )}

                                {enableXBtn && (
                                    <button
                                        className="ab-close-widget-btn"
                                        onClick={() => showWidget(false)}
                                    >
                                        <FaChevronDown size={12} />
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                    {toggleWidgetRoundBtn?.chatEnabled && (
                        <div
                            className="ab-chat-btn"
                            onClick={chatBtnOnClick}
                            style={openWidgetButtonStyles}
                        >
                            <BsChat size={20} />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

ToggleWidgetRoundBtn.propTypes = {
    chatBtnOnClick: PropTypes.func,
    toggleWidgetRoundBtn: PropTypes.object,
    toggleWidget: PropTypes.func.isRequired,
    widgetPosition: PropTypes.object,
    showWidget: PropTypes.func.isRequired,
    enableXBtn: PropTypes.bool,
    ourPrice: PropTypes.object,
    showOnlyWhenClosed: PropTypes.bool,
    showCta: PropTypes.bool,
};

export default ToggleWidgetRoundBtn;
